export default __webpack_public_path__ + "static/media/herb-ape.453641b1.png";